import * as actionTypes from '../actions/actionTypes';
import {updateObject} from "../../utility";

const initialState = {
    error: null,
    loading: false,
    alerts: {alerts: []},
};

const fetchAlertsStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const fetchAlertsSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, alerts: action.alerts})
};

const fetchAlertsFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ALERTS_FETCH_START: return fetchAlertsStart(state, action);
        case actionTypes.ALERTS_FETCH_SUCCESS: return fetchAlertsSuccess(state, action);
        case actionTypes.ALERTS_FETCH_FAIL: return fetchAlertsFail(state, action);
        default: return state;
    }
};

export default reducer;